module.exports = __webpack_public_path__ + "static/media/tennessee.c9614997.svg";